import { Module } from 'vuex';

import { MediaState } from '../../models';

import { SetViewportWidthAction } from '../../store/media/actions/set-viewport-width.action';
import { DeviceGetter } from '../../store/media/getters/device.getter';
import { MEDIA_CONSTS } from '../../store/media/media.consts';
import { SetViewportWidthMutation } from '../../store/media/mutations/set-viewport-width.mutation';

export const MEDIA_MODULE: Module<MediaState, any> = {
  namespaced: true,

  state: (): MediaState => {
    return {
      viewportWidth: window.innerWidth
    };
  },

  getters: {
    [MEDIA_CONSTS.getters.device]: DeviceGetter.execute
  },

  actions: {
    [MEDIA_CONSTS.actions.setViewportWidth]: SetViewportWidthAction.execute
  },

  mutations: {
    [MEDIA_CONSTS.mutations.setViewportWidth]: SetViewportWidthMutation.execute
  }

};
